import FilterListIcon from '@mui/icons-material/FilterList';
import {styled} from '@mui/material/styles';
import {flexRender} from '@tanstack/react-table';
import React, {useState} from 'react';

import {pxToRem} from '../../utils';

import CustomPopover from './CustomPopover';

const StyledTableHead = styled('thead')(({theme}) => ({
  display: 'table-header-group',
  background: theme.palette.primary.light,
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

const StyledTableHeadCell = styled('th')(({theme, filterable}) => ({
  color: theme.palette.primary.dark2,
  padding: `${pxToRem(12)} ${pxToRem(12)}`,
  cursor: filterable ? 'pointer' : 'default',
  '&:hover': {
    backgroundColor: filterable ? theme.palette.primary.medium2 : 'initial',
  },
  maxWidth: pxToRem(250),
  whiteSpace: 'nowrap',
  textAlign: 'left',
}));

const StyledDiv = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: pxToRem(2),
}));

const FilterHead = ({
  column,
  filters,
  setFilters,
  openCustomDateSelection,
  setOpenCustomDateSelection,
  allowDateRangeSelection,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const closeFilterPopup = () => {
    setAnchorEl(null);
  };

  const openFilterPopover = (event) => {
    setAnchorEl(event.target);
  };

  return (
    <>
      <StyledDiv onClick={openFilterPopover}>
        {column?.columnDef?.header} <FilterListIcon style={{fontSize: pxToRem(14)}} />
      </StyledDiv>
      <CustomPopover
        column={column}
        headerAchorEl={anchorEl}
        closeFilterPopup={closeFilterPopup}
        filters={filters}
        setFilters={setFilters}
        openCustomDateSelection={openCustomDateSelection}
        setOpenCustomDateSelection={setOpenCustomDateSelection}
        allowDateRangeSelection={allowDateRangeSelection}
      />
    </>
  );
};

const TableHead = ({
  tableInstance,
  filters,
  setFilters,
  openCustomDateSelection,
  setOpenCustomDateSelection,
  allowDateRangeSelection,
}) => {
  return (
    <>
      <StyledTableHead>
        {tableInstance.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => {
              return (
                <StyledTableHeadCell
                  key={header.id}
                  colSpan={header.colSpan}
                  filterable={header.column.columnDef?.filterable}
                >
                  {header.isPlaceholder ? null : header.column.columnDef?.filterable ? (
                    <FilterHead
                      column={header?.column}
                      filters={filters}
                      setFilters={setFilters}
                      openCustomDateSelection={openCustomDateSelection}
                      setOpenCustomDateSelection={setOpenCustomDateSelection}
                      allowDateRangeSelection={allowDateRangeSelection}
                    />
                  ) : (
                    <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>
                  )}
                </StyledTableHeadCell>
              );
            })}
          </tr>
        ))}
      </StyledTableHead>
    </>
  );
};

export default TableHead;
